
import api from '@/services/api';
import _ from 'underscore';
import {Module} from 'vuex';
import {RootState} from '@/types';

export interface MetaState {
    env: string;
    jobCorpsDatabase: string;
    trainDatabase: string;
    override: boolean;
    version: string;
}

export const MetaStore: Module<MetaState, RootState> = {
    namespaced: true,

    state: {
        env: 'dev',
        jobCorpsDatabase: '',
        trainDatabase: '',
        override: false,
        version: ''
    },

    getters: {
        getMeta: (state) => (): MetaState => {
            return state;
        },
        getMetaString: (state): string => {
            if ('prod' !== state.env) {
                return state.version + ' on ' + state.env;
            } else {
                return state.version;
            }
        }
    },

    mutations: {
        setMeta: (state, s: MetaState) => {
            state.env = s.env;
            state.jobCorpsDatabase = s.jobCorpsDatabase;
            state.trainDatabase = s.trainDatabase;
            state.version = s.version;
        },

        toggleOverride: (state) => {
            state.override = !state.override;
        }
    },

    actions: {
        loadMeta({state, commit}) {
            api().get('/meta')
                .then((response) => {
                    commit('setMeta', response.data as MetaState);

                });
        },

        toggleOverride({commit}) {
            commit('toggleOverride');
        }
    }
};
